import { render, staticRenderFns } from "./ActorList.vue?vue&type=template&id=1720a131&scoped=true&"
import script from "./ActorList.vue?vue&type=script&lang=ts&"
export * from "./ActorList.vue?vue&type=script&lang=ts&"
import style0 from "./ActorList.vue?vue&type=style&index=0&id=1720a131&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720a131",
  null
  
)

export default component.exports